import { useQuery } from '@tanstack/react-query';
import { QueryResult } from 'lib/types/utility';
import { BookingGateway } from 'services/http/booking-gateway';
import { sessionIdService } from 'services/session-id/session-id.service';

export type ReferralCodeQueryResult = QueryResult<{
  code: string;
}>;

const useReferralCodeQuery = () => {
  const URL = '/public/promotion/referral';
  const sessionId = sessionIdService.get();

  return useQuery(
    ['referral-code', sessionId],
    async () => {
      const response = await BookingGateway.get<ReferralCodeQueryResult>(URL);
      return response;
    },
    {
      staleTime: 20 * 1000,
      enabled: !!sessionId.length,
    }
  );
};

export { useReferralCodeQuery };
